import React from "react"
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core"

import BaseButton, { BaseProps } from "../../../../../../Links/Item/Button"
import links from "../../../../../../../constants/links"
import Email from "./Email"
import Chat from "./Chat"
import Instagram from "./Instagram"
import Facebook from "./Facebook"
import Youtube from "./YouTube"

const styles = ({
  breakpoints: { up },
  palette: {
    text: { primary },
  },
}: Theme) => {
  const upMd = up("md")
  return createStyles({
    root: {
      fontSize: "1.125rem",
    },
    icon: {
      width: "0.875rem",
      marginRight: "0.5rem",
      fill: primary,
      [upMd]: {
        marginRight: "1.3125rem",
      },
    },
  })
}

interface Props extends WithStyles<typeof styles>, BaseProps {
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

type Icon = React.FunctionComponent<React.SVGProps<SVGSVGElement>> | null

const Button = ({ classes, children, href, ...other }: Props) => {
  const renderIcon = (): Icon => {
    switch (href) {
      case links.email:
        return Email
      case links.instagram:
        return Instagram
      case links.message:
        return Chat
      case links.youtube:
        return Youtube
      case links.facebook:
        return Facebook
      default:
        return null
    }
  }

  const IconComponent: Icon = renderIcon()

  return (
    <BaseButton classes={{ root: classes.root }} href={href} {...other}>
      {IconComponent && <IconComponent className={classes.icon} />}
      {children}
    </BaseButton>
  )
}

export default withStyles(styles)(Button)
